"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { isInterviewSessionPath } from "@/lib/paths";
import { NOTE_URL, SNS_LINKS } from "@/lib/snsLinks";

export default function AppFooter() {
  const pathname = usePathname();

  // 面接セッション中はフッターを隠し、没入表示にする
  if (isInterviewSessionPath(pathname)) return null;

  return (
    <footer className="w-full bg-gray-900 text-gray-100 py-6">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 px-5 md:px-10 max-w-7xl mx-auto">
        {/* メニュー: モバイル時は左揃え縦並び、PC 時は右寄せで横並び。
            order を使って、モバイルでメニュー→コピーライトの順、PC でコピーライト→メニューの順にする */}
        <div className="flex flex-col items-start gap-3 order-1 sm:flex-row sm:items-center sm:gap-6 sm:order-2">
          <Link
            href="/how-to-use"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            使い方
          </Link>
          <Link
            href="/guides"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            ナレッジ記事
          </Link>
          <Link
            href="/contact"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            お問い合わせ
          </Link>
          <Link
            href="/agreement"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            利用規約
          </Link>
          <Link
            href="/privacy"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            プライバシーポリシー
          </Link>
          <a
            href="https://www.x-hack.jp/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            運営会社
          </a>
          <a
            href={NOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-100 hover:text-primary text-xs transition-colors"
          >
            公式note
          </a>
          {/* SNSアイコン群: モバイルでも横1行に並べる */}
          <div className="flex flex-row items-center gap-4">
            {SNS_LINKS.map((sns) => (
              <a
                key={sns.label}
                href={sns.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-100 hover:text-primary transition-colors p-2 -m-2"
                aria-label={sns.label}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d={sns.svgPath} />
                </svg>
              </a>
            ))}
          </div>
        </div>
        {/* コピーライト: モバイル時はメニュー下に中央揃え、PC 時は左側 */}
        <p className="text-xs text-center order-2 sm:text-left sm:order-1">© 2026 MENREN</p>
      </div>
    </footer>
  );
}
